import { useSelector } from '@legendapp/state/react';
import { extractForms } from '@tf/shared';
import type React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { useEntity } from '@/core/api/entities';
import { appStore } from '@/core/stores';

export const NavigateToFirstEntityFormRoute: React.FC = () => {
	const { entityId } = useParams<{ entityId: string }>();
	const formDefs = useSelector(() => appStore.defs.get().forms);

	const { data: entity } = useEntity(Number(entityId));

	if (!entity) return null;

	const forms = extractForms({
		formDefs,
		segmentIdentities: entity.listSegments.map((s) => s.SegmentIdentity),
	});

	const firstForm = forms[0];

	return <Navigate to={`${firstForm.name}`} replace />;
};
